import { Pipe, PipeTransform } from '@angular/core';
import { ProgramDay, Session } from 'globals/store/programs.data';
import { addTrailingSpace, getTimeZonedDateFromUTCTimeAndTimeZoneId } from '../../helpers/helpers';
import { findTimeZone, getZonedTime } from 'timezone-support';

@Pipe({
    name: 'daySecondaryTimezoneText',
    standalone: true
})
export class SecondaryTimezoneDayPipe implements PipeTransform {
  transform(day: ProgramDay, STZAbbr: string): string {
    if (!STZAbbr || !day.startForStz) return ''
    const { dayOffset, time } = day.startForStz
    return ` (${addTrailingSpace(dayOffset)}${time} ${STZAbbr})`
  }
}

@Pipe({
    name: 'sessionSecondaryTimezoneText',
    standalone: true
})
export class SecondaryTimezoneSessionPipe implements PipeTransform {
  transform(session: Session, STZAbbr: string): string {
    if (!STZAbbr || !session.startForStz || !session.endForStz) return ''
    const start = session.startForStz
    const end = session.endForStz
    return `(${addTrailingSpace(start.dayOffset)}${start.time} - ${addTrailingSpace(end.dayOffset)} ${end.time} ${STZAbbr})`
  }
}

@Pipe({
    name: 'userSelectedPublishTimezoneText',
    standalone: true
})
export class UserSelectedPublishTimezoneTextPipe implements PipeTransform {
  transform(epoch: number, timezone: any): string {
    if (!epoch) return ''
    const date = new Date(epoch).toLocaleTimeString([], {year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit'})
    if (!timezone) return date
    const timezoneAbbr = getZonedTime(epoch, timezone).zone.abbreviation
    return `${date} ${timezoneAbbr}`;
  }
}

@Pipe({
    name: 'zonedDatePipe',
    standalone: true
})
export class ZonedDatePipe implements PipeTransform {
  transform(utcTime: number, timeZoneId: string): Date {
    if (!utcTime) return new Date()
    if (!timeZoneId) return new Date(utcTime)
    return getTimeZonedDateFromUTCTimeAndTimeZoneId(utcTime, timeZoneId)
  }
}


@Pipe({
    name: 'timeZoneAbbreviationPipe',
    standalone: true
})
export class TimeZonePipe implements PipeTransform {
  transform(utcTime: number, timeZoneId: string): string {
    const timeZone = findTimeZone(timeZoneId)
    return getZonedTime(utcTime, timeZone).zone.abbreviation
  }
}